module.exports = __webpack_public_path__ + "static/media/Graphs.6cb78991.gif";